<body class="home">
     
    <div id="page" class="page">
       <!-- site header html start  -->
       <app-smart-header></app-smart-header>
       <div #home></div>
       <!-- site header html end  -->
       <main id="content" class="site-main">
          <!-- ***home banner html start form here*** -->
          <section class="home-banner-section home-banner-slider">
             <div class="home-banner d-flex flex-wrap align-items-center" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/e443a991-6970-45da-f5f4-4551c157c100/public);">
                <div class="overlay"></div>
                <div class="container">
                   <div class="banner-content text-center">
                      <div class="row">
                         <div class="col-lg-8 offset-lg-2">
                            <h1 class="banner-title">VOYJALEAS</h1>
                            <p>Servicio de consultoría para viajar, estudiar, trabajar o vivir en España.                            </p>
                            <div class="banner-btn">
                               <!-- <a href="javascript: void(0)" class="round-btn" (click)="scrollToElement('packsoffer')">Me interesa</a> -->
                               <a href="javascript: void(0)" (click)="goToCalendly()" class="outline-btn outline-btn-white">Videollamada inicial gratis</a>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </section>

          <section id="terminos-condiciones">
            <h1>Términos y Condiciones de Uso</h1>
            <p><strong>Última actualización:</strong> 12 de abril de 2025</p>
          
            <p>POR FAVOR, LEE DETENIDAMENTE ESTOS TÉRMINOS Y CONDICIONES ANTES DE UTILIZAR ESTE SITIO WEB.</p>
            <h2>1. Objeto</h2>
            <p>Los presentes Términos y Condiciones regulan el acceso y uso de los servicios ofrecidos por VoyJaleas, marca personal gestionada por Sebastián Jiménez Benavides, a través de su sitio web, aplicaciones, y canales de comunicación directa, destinados a gestionar trámites y asesorías de seguros médicos en colaboración con corredurías y otras entidades profesionales.</p>
          
            <h2>2. Condiciones de uso</h2>
            <p>El uso de los servicios de VoyJaleas implica la aceptación plena y sin reservas de los presentes términos. El usuario se compromete a utilizar los servicios de forma lícita, honesta y sin causar daños a terceros o a los sistemas utilizados por VoyJaleas.</p>
          
            <h3>2.1 Objetivo del chat de Whatsapp</h3>
            <p>Responder en línea consultas generales de nuestros clientes,los procesos en curso,  productos y servicios de VoyJaleas.</p>

            <h3>2.2 Normas y condiciones</h3>
            <p>Todos los usuarios del whatsapp chat, sin ninguna excepción, deben cumplir con las normas y políticas de uso de estos espacios virtuales descritas en este documento, en caso de que el usuario del chat (grupo de whatsapp) no cumpla con las normas el asesor podrá bloquear su participación en el canal de atención virtual.
            </p>

            <p>Las comunicaciones vía Whatsapp se harán mediante un grupo en el cuál estará la persona que ha contratado el servicio, así como los miembros del equipo que van a atender la consultoría.
            </p>

            <p>Está prohibido el uso de vocabulario inapropiado, vulgar, obsceno, abusivo, difamatorio, xenófobo, calumnioso, ofensivo, peyorativo, sexual, discriminatorio, racistas y/o amenazante y otros que atenten contra la dignidad de alguna persona o empleado.

               Está restringido colocar cualquier tipo de vínculos a distintas páginas web no autorizadas por los administradores del grupo de whatsapp, imágenes, virus o correo/mensajes basura (spam). De igual forma está prohibido que los usuarios utilicen ese medio con fines publicitarios.
               
               El acceso y atención a través del chat no tiene ningún costo adicional al precio del paquete elegido.
               </p>

            <h2>3. Naturaleza del servicio</h2>
            <p>VoyJaleas no actúa como aseguradora ni correduría de seguros. Actúa como colaborador independiente, facilitando la comunicación entre el cliente y la correduría Rosillo Hermanos Correduría de Seguros S.A. con el objetivo de ayudar al cliente a gestionar la contratación de seguros médicos u otros servicios relacionados.</p>
          
            <h3>3.1 Período de validez del servicio de consultoría</h3>
            <p>La finalización de nuestros servicios de consultoría será en el momento en el que se cumplan todos los servicios elegidos en el plan elegido por el interesado.
               En el caso en el que el cliente haga uso de todas las sesiones de videollamadas estipuladas en el paquete elegido, se cobrarán de forma adicional videollamadas futuras con la tarifa establecida por Voy Jaleas.
               </p>

            <h3>3.2 Contratación</h3>
            <p>El servicio de Voy Jaleas dará inicio en el momento en el que se cumplan los siguientes requisitos;</p>

            <ul>
               <li>Confirmación por escrito por parte del interesado, en respuesta al correo enviado con la cotización.</li>
               <li>Una vez que el equipo de Voy Jaleas haya confirmado la recepción de la transferencia bancaria por el monto definido en el paquete de elección del cliente.
               </li>
               <li>Los servicios contratados por aparte que no estén definidos en el paquete elegido por el cliente deberán ser abonados mediante transferencia bancaria.</li>
            </ul>


            <h2>4. Responsabilidad</h2>
            <p>VoyJaleas no será responsable de decisiones tomadas por las compañías aseguradoras ni de los resultados derivados de la contratación del servicio, actuando exclusivamente como canal de comunicación e intermediación con base en la información facilitada por el cliente.</p>
          
            <h3>4.1 Sobre la contratación de la consultoría para obtener el visado de estudios</h3>
               <p>La contratación del servicio de consultoría no asegura el resultado del viaje, o bien de la concesión del visado por parte de la embajada de España en Costa Rica.</p>

            <h3>4.2 CONDICIONES GENERALES DEL CONTRATO DE SERVICIOS DE CONSULTORÍA            </h3>

            <p>1) El precio y/o reservación de los servicios que componen el paquete será el indicado en el documento de la cotización enviado al cliente. En caso de algún error en el precio de la cotización se realizará una corrección y se comunicará al cliente del error. </p>
            <p>2) Todos los importes pagados antes de la confirmación definitiva de los servicios son percibidos en concepto de reserva. La confirmación definitiva de los servicios y precios respectivos se producirá con la emisión de la transferencia bancaria a la cuenta indicada en el documento de cotización enviado al cliente. </p>

            <h2>5. Obligaciones del usuario</h2>
            <p>El usuario garantiza que los datos proporcionados son veraces, completos y actualizados. Será responsable por cualquier daño o perjuicio que pueda derivarse del incumplimiento de esta obligación.</p>
          
            <h2>6. Protección de datos</h2>
            <p>El tratamiento de los datos personales se rige por la Política de Privacidad disponible en esta web, que el usuario acepta expresamente antes de enviar cualquier dato personal.</p>
          
            <h2>7. Propiedad intelectual</h2>
            <p>Todos los contenidos de la web y los materiales ofrecidos por VoyJaleas son propiedad intelectual del titular, salvo que se indique lo contrario. Queda prohibida su reproducción sin autorización previa y por escrito.</p>
            <p>Sebastián Jiménez Benavides es propietario de este sitio y posee las autorizaciones correspondientes para el uso de contenidos tales como: imágenes, gráficas, caracteres , textos, software, videos entre otros, así como de las codificaciones HTML, CSS, PHP y otros códigos utilizadas para implementar este sitio.
               Ningún código o contenido podrá ser modificado, copiado, distribuido, retransmitido, utilizado, reproducido y/o publicado bajo ningún concepto, con excepción de lo que esté expresamente autorizado por estas normas y en las instrucciones de cada sección de este sitio.
               </p>

            <p>El sitio web app.voyjaleas.com ha sido diseñado única y exclusivamente para su uso personal y los servicios que hayan sido contratados podrán ser utilizados únicamente por el usuario que se ha registrado y ha pagado por el(los) servicios. Es prohibido comercializar el contenido, información, software, productos y servicios obtenidos de este sitio.
               Los contenidos de este sitio web están registrados bajo las leyes de Copyright, es marca registrada de VoyJaleas.
               Si usted tiene conocimiento de una infracción de nuestra marca, por favor háganoslo saber al e-mail voyjaleas.cr@gmail.com
               </p>
          
            <h2>8. Modificaciones</h2>
            <p>VoyJaleas podrá modificar los presentes Términos y Condiciones cuando lo considere oportuno. Las modificaciones entrarán en vigor en el momento de su publicación.</p>
          
            <h2>9. Legislación aplicable</h2>
            <p>Estos Términos se rigen por la legislación costarricenses. Para cualquier conflicto o disputa, las partes se someterán a los Juzgados y Tribunales de la ciudad de San José, salvo que por ley corresponda otro fuero.</p>
          </section>
          

          <section class="home-callback bg-color-callback primary-bg">
             <div class="container">
                <div class="row align-items-center">
                   <div class="col-md-8">
                      <h5 class="sub-title">RESERVA TU VIDEOLLAMADA GRATUITA Y </h5>
                      <h2 class="section-title">COMENCEMOS A PLANEAR TU AVENTURA!!</h2>
                      <p>Nos encantaría conocerte y escuchar tu historia. Agendá una llamada con nuestro equipo para hablar sobre tus necesidades.</p>
                   </div>
                   <div class="col-md-4 text-md-end">
                      <a href="javascript:void(0)" (click)="buyProductSimple('videocall60')" class="outline-btn outline-btn-white">RESERVAR VIDEOLLAMADA</a>
                   </div>
                </div>
             </div>
          </section>
          <!-- ***Home callback html end here*** -->
       </main>
       <!-- ***site footer html start form here*** -->
       <app-smart-footer></app-smart-footer>

       <!-- ***site footer html end*** -->
       <a id="backTotop" href="#" class="to-top-icon">
          <i class="fas fa-chevron-up"></i>
       </a>
       <!-- ***custom search field html*** -->
       <div class="header-search-form">
          <div class="container">
             <div class="header-search-container">
                <form class="search-form" role="search" method="get" >
                   <input type="text" name="s" placeholder="Enter your text...">
                </form>
                <a href="#" (click)="goToPage('home')" class="search-close">
                   <i class="fas fa-times"></i>
                </a>
             </div>
          </div>
       </div>
       <!-- ***custom search field html*** -->
       <!-- ***custom top bar offcanvas html*** -->
       <div id="offCanvas" class="offcanvas-container">
          <div class="offcanvas-inner">
             <div class="offcanvas-sidebar">
                <aside class="widget author_widget">
                   <h3 class="widget-title">OUR PROPRIETOR</h3>
                   <div class="widget-content text-center"> 
                      <div class="profile"> 
                         <figure class="avatar"> 
                            <img src="assets/images/img21.jpg" alt=""> 
                         </figure> 
                         <div class="text-content"> 
                            <div class="name-title"> 
                               <h4> James Watson</h4> 
                            </div> 
                            <p>Accumsan? Aliquet nobis doloremque, aliqua? Inceptos voluptatem, duis tempore optio quae animi viverra distinctio cumque vivamus, earum congue, anim velit</p> 
                         </div> 
                         <div class="socialgroup"> 
                            <ul> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-facebook"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-google"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-twitter"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-instagram"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-pinterest"></i> </a> </li> 
                            </ul> 
                         </div> 
                      </div> 
                   </div>
                </aside>
                <aside class="widget widget_text text-center">
                   <h3 class="widget-title">CONTACT US</h3>
                   <div class="textwidget widget-text">
                      <p>Feel free to contact and<br/> reach us !!</p>
                      <ul>
                         <li>
                            <a href="tel:+01988256203">
                               <i aria-hidden="true" class="icon icon-phone1"></i>
                               +01(988) 256 203
                            </a>
                         </li>
                         <li>
                            <a href="mailtop:info@domain.com">
                               <i aria-hidden="true" class="icon icon-envelope1"></i>
                               info@domain.com
                            </a>
                         </li>
                         <li>
                            <i aria-hidden="true" class="icon icon-map-marker1"></i>
                            3146 Koontz, California
                         </li>
                      </ul>
                   </div>
                </aside>
             </div>
             <a href="#" (click)="goToPage('home')" class="offcanvas-close">
                <i class="fas fa-times" (click)="goToPage('home')"></i>
             </a>
          </div>
          <div class="overlay"></div>
       </div>
       <!-- ***custom top bar offcanvas html*** -->
    </div>

  
 </body>
  